
/**
 * 계정 상태
 */
export type UserResponseStatus = typeof UserResponseStatus[keyof typeof UserResponseStatus];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const UserResponseStatus = {
  ACTIVE: 'ACTIVE',
  INACTIVE: 'INACTIVE',
  SUSPENDED: 'SUSPENDED',
  DELETED: 'DELETED',
} as const;
